import script from "./taxesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./taxesPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__